import {useMediaQuery} from "@chakra-ui/react";

export default function useIsDesktop(cutoff = 640): boolean {
    const [isDesktop] = useMediaQuery(`(min-width: ${cutoff}px)`)
    return isDesktop
}